/**
 * Aura AGM (AUDITED · Multiple member) preset
 *   (my_preset / sg / aura / agm-multi-audited) — 자체완결 모듈, 자체등록.
 *
 * 매칭 = task code CAU005 (Aura 접두어 CAU).
 *   priority 58 (agm 55 / agm-multi(unaudited) 56 / agm-sole-corp 57 보다 높게 — 코드 전용이라 충돌은 없지만 명시).
 * 배선: sg/aura/index.ts 가 이 모듈을 import 하면 로드 시 자동 등록.
 *
 * agm-multi(Unaudited, Small Company/Solvency)와 달리 **Audited**:
 *   AGM Documents = DRW(Audited) · Notice(Audited, 감사인 재선임) · Consent(members) ·
 *   Minutes(Chairman, 감사인) · Attendance List. (Small Company/Solvency 없음.)
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAuraAgmMultiAuditedPanel from './components/PreSetAuraAgmMultiPanel.vue';
import { auraAgmMultiAuditedFlow } from './chatflows/auraAgmMultiFlow';

export { default as PreSetAuraAgmMultiAuditedPanel } from './components/PreSetAuraAgmMultiPanel.vue';
export { auraAgmMultiAuditedFlow } from './chatflows/auraAgmMultiFlow';

/** 공통코드 — Aura AGM (Audited, Multiple member) 은 CAU005 로 발급됨. */
export const AURA_AGM_MULTI_AUDITED_TASK_CODES: string[] = ['CAU005'];

export function matchesAuraAgmMultiAudited(sel: PreSetSelection): boolean {
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AURA_AGM_MULTI_AUDITED_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAuraAgmMultiAuditedPreset(): void {
  registerChatFlow(auraAgmMultiAuditedFlow);
  registerPanel({
    id: 'aura-agm-multi-audited',
    priority: 58,
    match: (sel) => matchesAuraAgmMultiAudited(sel),
    component: PreSetAuraAgmMultiAuditedPanel,
    meta: { docType: 'SG_AGM_MULTI_AUDITED_PRE', studio: true },
  });
}

registerAuraAgmMultiAuditedPreset();
